module.exports = __webpack_public_path__ + "static/img/3.b0204f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/zh/3.png
// module id = FOUq
// module chunks = 0